import React from 'react';
import { forecasts } from '../../data/forecasts';
import { clients } from '../../data/clients';
import { format, addHours, startOfDay } from 'date-fns';
import { fr } from 'date-fns/locale';
import { CloudSnow } from 'lucide-react';
export function ScheduleTimeline() {
  // Group forecasts by day
  const forecastsByDay = forecasts.reduce((acc, forecast) => {
    const dayKey = format(forecast.eventStart, 'yyyy-MM-dd');
    if (!acc[dayKey]) {
      acc[dayKey] = [];
    }
    acc[dayKey].push(forecast);
    return acc;
  }, {} as Record<string, typeof forecasts>);
  const sortedDays = Object.keys(forecastsByDay).sort();
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-555">
      <div className="p-6 border-b border-gray-200" data-id="element-556">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-557">
          Chronologie des interventions
        </h2>
        <p className="text-sm text-gray-600 mt-1" data-id="element-558">
          Planning basé sur les prévisions météo
        </p>
      </div>
      <div className="p-6 space-y-8" data-id="element-559">
        {sortedDays.map(dayKey => {
        const dayForecasts = forecastsByDay[dayKey].sort((a, b) => a.eventStart.getTime() - b.eventStart.getTime());
        const dayDate = new Date(dayKey);
        return <div key={dayKey} data-id="element-560">
              {/* Day Header */}
              <div className="flex items-center space-x-3 mb-4" data-id="element-561">
                <div className="flex-shrink-0 w-16 h-16 bg-blue-100 rounded-lg flex flex-col items-center justify-center" data-id="element-562">
                  <span className="text-2xl font-bold text-blue-600" data-id="element-563">
                    {format(dayDate, 'dd')}
                  </span>
                  <span className="text-xs text-blue-600 uppercase" data-id="element-564">
                    {format(dayDate, 'MMM', {
                  locale: fr
                })}
                  </span>
                </div>
                <div data-id="element-565">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-566">
                    {format(dayDate, 'EEEE d MMMM yyyy', {
                  locale: fr
                })}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-567">
                    {dayForecasts.length} événement(s) prévu(s)
                  </p>
                </div>
              </div>
              {/* Timeline */}
              <div className="ml-8 border-l-2 border-gray-200 pl-6 space-y-6" data-id="element-568">
                {dayForecasts.map(forecast => {
              const client = clients.find(c => c.id === forecast.clientId);
              if (!client) return null;
              const duration = (forecast.eventEnd.getTime() - forecast.eventStart.getTime()) / (1000 * 60 * 60);
              return <div key={forecast.id} className="relative" data-id="element-569">
                      {/* Timeline Dot */}
                      <div className="absolute -left-[33px] w-4 h-4 bg-blue-600 rounded-full border-4 border-white" data-id="element-570"></div>
                      <div className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors cursor-pointer" data-id="element-571">
                        <div className="flex items-start justify-between" data-id="element-572">
                          <div className="flex-1" data-id="element-573">
                            <div className="flex items-center space-x-3 mb-2" data-id="element-574">
                              <CloudSnow className={`w-5 h-5 ${forecast.intensity === 'forte' ? 'text-red-600' : forecast.intensity === 'modérée' ? 'text-orange-600' : 'text-blue-600'}`} data-id="element-575" />
                              <div data-id="element-576">
                                <h4 className="text-sm font-semibold text-gray-900" data-id="element-577">
                                  {client.name}
                                </h4>
                                <p className="text-xs text-gray-500" data-id="element-578">
                                  {client.address.city}
                                </p>
                              </div>
                            </div>
                            <div className="flex items-center space-x-4 text-sm" data-id="element-579">
                              <span className="text-gray-700" data-id="element-580">
                                <span className="font-medium" data-id="element-581">
                                  {format(forecast.eventStart, 'HH:mm')}
                                </span>{' '}
                                →{' '}
                                <span className="font-medium" data-id="element-582">
                                  {format(forecast.eventEnd, 'HH:mm')}
                                </span>
                              </span>
                              <span className="text-gray-500" data-id="element-583">
                                ({duration.toFixed(1)}h)
                              </span>
                              <span className={`px-2 py-1 rounded-full text-xs font-medium ${forecast.intensity === 'forte' ? 'bg-red-100 text-red-700' : forecast.intensity === 'modérée' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`} data-id="element-584">
                                {forecast.accumulation.median} cm
                              </span>
                            </div>
                            <div className="mt-2 flex items-center space-x-3 text-xs text-gray-600" data-id="element-585">
                              <span data-id="element-586">Type: {forecast.type}</span>
                              <span data-id="element-587">•</span>
                              <span data-id="element-588">Temp: {forecast.temperature}°C</span>
                              <span data-id="element-589">•</span>
                              <span data-id="element-590">Vent: {forecast.windSpeed} km/h</span>
                              <span data-id="element-591">•</span>
                              <span data-id="element-592">SLA: {client.slaHours}h</span>
                            </div>
                          </div>
                          {forecast.triggeredIntervention && <div className="ml-4 px-3 py-1.5 bg-green-100 text-green-700 rounded-lg text-xs font-medium" data-id="element-593">
                              Intervention planifiée
                            </div>}
                        </div>
                      </div>
                    </div>;
            })}
              </div>
            </div>;
      })}
      </div>
    </div>;
}